import React from 'react';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const CommerceLabel = Atom.createRender((props) => {
  const {attributes, data, classes, generateAttributes, renderChild} = props;
  return (
    // TODO: fix jsx-a11y lint error
    // eslint-disable-next-line jsx-a11y/label-has-for
    <label {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </label>
  );
});

const config = createIntegratedAtom({
  displayName: 'Field Label',
  showEmpty: false,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginTop: px(20),
          marginBottom: px(8),
        },
      },
    },
  },
  render: CommerceLabel,
  fields: {children: TListOfElement},
});

export default config;
